export default __webpack_public_path__ + "static/media/user-icon.90571f0d.png";